// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1h2kF","actions":"GroupTable_actions__wevYC","deleteModalFooter":"GroupTable_deleteModalFooter__JCxtc"};